// extracted by mini-css-extract-plugin
module.exports = {"appVersionToast":"AppVersion_appVersionToast__2w8t7","actionButton":"AppVersion_actionButton__2PKLc"};